<!-- 税込ベース割引（定額割引コード適用時）の内訳行 -->
<template>
  <div class="inline-flex items-end justify-start gap-2 self-stretch">
    <div class="flex-1 justify-start font-Spectral text-sm font-light leading-tight text-light-fg-muted">Discount</div>
    <div class="justify-start text-right font-Spectral text-sm font-normal leading-tight text-light-fg-muted" data-testid="discountAmount">- {{ discountDisplay }}</div>
  </div>
</template>

<script setup lang="ts">
interface Props {
  /** 割引額（表示用文字列） */
  discountDisplay: string;
}

defineProps<Props>();
</script>
